import { render, staticRenderFns } from "./ListMerchant.vue?vue&type=template&id=1ffe282d"
import script from "./ListMerchant.vue?vue&type=script&lang=js"
export * from "./ListMerchant.vue?vue&type=script&lang=js"
import style0 from "./ListMerchant.vue?vue&type=style&index=0&id=1ffe282d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports